import dayjs from 'dayjs'
import { formatDateUTC } from 'src/utils/formatDate'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const batchMapper = (batch) => {
  return {
    modelId: batch.id_modelo,
    batchId: batch.id_lote,
    createdAt: dayjs(batch.data_entrada ? batch.data_entrada : batch.data_inclusao),
    expirationDate: dayjs.utc(formatDateUTC(batch.data_validade, 'YYYY-MM-DD'), 'YYYY-MM-DD'),
    damageType: batch.tipo_avaria,
    damageQuantity: batch.quantidade_avaria,
    description: batch.descricao,
    barcode: batch.codigo_de_barras_utilizado,
    total: batch.quantidade_total,
    isDirectShelf: batch.direto_gondola,
    warehouse: batch.address_detail?.warehouse,
    street: batch.address_detail?.aisle,
    addressTag: batch.address_tag?.endereco_generated,
    shelfPallet: batch.address_detail?.shelfPallet,
    binPosition: batch.address_detail?.binPosition,
    addressNotGondola: batch.address,
    productCode: batch.cod_produto,
    fc: batch.fc,
    batchNumber: batch.batch_number,
    measureUnit: {
      isKg: batch.measure_unit?.is_kg
    },
    suggestedStorageReceivement: batch.suggested_storage_receivement,
  }
}


export const batchMapperCamelCase = (batch) => {
  return {
    modelId: batch.idModelo,
    batchId: batch.idLote,
    createdAt: dayjs(batch.dataEntrada ? batch.dataEntrada : batch.dataInclusao),
    expirationDate: dayjs.utc(formatDateUTC(batch.dataValidade, 'YYYY-MM-DD'), 'YYYY-MM-DD'),
    damageType: batch.tipoAvaria,
    damageQuantity: batch.quantidadeAvaria,
    description: batch.descricao,
    barcode: batch.codigoDeBarrasUtilizado,
    total: batch.quantidadeTotal,
    isDirectShelf: batch.diretoGondola,
    warehouse: batch.addressDetail?.warehouse,
    street: batch.addressDetail?.aisle,
    addressTag: batch.addressTag?.rua,
    shelfPallet: batch.addressDetail?.shelfPallet,
    binPosition: batch.addressDetail?.binPosition,
    addressNotGondola: batch.address,
    productCode: batch.codProduto,
    fc: batch.fc,
    measureUnit: {
      isKg: batch.measureUnit?.isKg
    },
    batchNumber: batch.batchNumber
  }
}
